import React from 'react'
import axios from 'axios'
import Uploader from './../components/uploader'
import ShowSelect from './../components/show_select'

// const YearSelect = (props) => {
// 	let yearOptions = []
// 	for(var i=props.startYear; i<(props.startYear + 4); i++){
// 		yearOptions.push(i)
// 	}
// 	return (
// 		<select className="graduation_year" defaultValue={props.selected}>
// 			<option value="">Enter Graduation Year...</option>
// 			{yearOptions.map( yearOption => <option key={yearOption} value={yearOption}>{yearOption}</option> )}
// 		</select>
// 	)
// }

const Item = ({item, shows, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<form className="row" data-id={item.id} onChange={ (e) => {update(e.target.closest('form'))} } onSubmit={submit}>
			<div className="col_3">
				{
					item.head_shot ?
						<img src={item.head_shot} alt={item.name} data-src={item.head_shot} /> :
						null
				}
				<Uploader
					className="head_shot_drop"
					uploadComplete={ (imageURL) => handleImageUploadComplete(imageURL, item.id) }
					label="Drop an image for head shot"
				/>
				{
				/*
				<label><input type="checkbox" checked={!!item.isSpotlight} className="isSpotlight" onChange={()=>{}} /> Is Spotlight Student</label>
				<input type="text" defaultValue={item.name ? decodeURIComponent(item.name) : ''} placeholder="Name" className="name" />
				*/
				}
			</div>
			<div className="col_4 row name_container">
				<label>Name</label>
				<div className="col_6">
					<input type="text" defaultValue={item.firstname ? decodeURIComponent(item.firstname) : ''} placeholder="First" className="firstname" />
				</div>
				<div className="col_6">
					<input type="text" defaultValue={item.lastname ? decodeURIComponent(item.lastname) : ''} placeholder="Last" className="lastname" />
				</div>

				{
				/*
				<label>Name</label>
				<input type="text" defaultValue={item.name ? decodeURIComponent(item.name) : ''} placeholder="Name" className="name" />
				*/
				}

				{
				/*
				<label>Graduation Year</label>
				<YearSelect startYear={(new Date()).getFullYear()} selected={item.graduation_year ? parseInt(item.graduation_year, 10) : null} />
				*/
				}
				<div className="hidden">
					<label>Current Show</label>
					<ShowSelect shows={shows} selectedShowId={item.show_id != null && shows.length && shows.filter( show => show.id === item.show_id ).length ?
						shows.filter( show => show.id === item.show_id )[0].id :
						-1} />
				</div>

				<label>Part</label>
				<input type="text" defaultValue={item.part ? decodeURIComponent(item.part) : ''} placeholder="Part" className="part" />
			</div>

			<div className="col_5">
				<label>Bio</label>
				<textarea defaultValue={item.bio ? decodeURIComponent(item.bio) : ''} placeholder="bio" className="bio"></textarea>

				<button type="delete" onClick={ () => {remove(item.id)}}>Delete {decodeURIComponent(item.firstname)}</button>
			</div>
		</form>
	)
}

const List = ({items, shows, remove, update, submit, handleImageUploadComplete}) => {
	return (
		<div className="items_container">
			{items.map( item => {
				return (<Item
					item={item}
					shows={shows}
					key={item.id}
					remove={remove}
					update={update}
					submit={submit}
					handleImageUploadComplete={handleImageUploadComplete} /> )
			})}
		</div>
	)
}

class Bios extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			readyToSave: false,
			changesSaved: false,
			message: '',
			shows: [],
			currentShowId: null
		}
	}

	componentDidMount(){
		this.fetchData(this.props.id)
		this.fetchShowData()
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'bios'
			}
		}).then( response => {
			this.setState({
				items: response.data.items.sort( (a, b) => {
					let nameA = a.lastname.toLowerCase(), nameB = b.lastname.toLowerCase()
					if(nameA < nameB)
						return -1
					if(nameA > nameB)
						return 1
					return 0
				})
			})
		})
	}

	fetchShowData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'shows'
			}
		}).then( response => {
			this.setState({
				shows: response.data.items.sort( (a, b) => {
					let nameA = a.title.toLowerCase(), nameB = b.title.toLowerCase()
					if(nameA < nameB)
						return -1
					if(nameA > nameB)
						return 1
					return 0
				})
			})
		})
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			firstname: '',
			lastname: '',
			// graduation_year: null,
			bio: '',
			show_id: this.state.currentShowId,
			show_title: null,
			part: '',
			// isSpotlight: false,
			head_shot: null
		})

		// Save it to state.
		this.setState({ items })
	}

	handleImageUploadComplete(imageURL, id){
		// Need to store the imageURL to the form.
		var items = this.state.items.map( item => {
			if(item.id === id){
				item.head_shot = imageURL
			}
			return item
		})

		this.setState({
			items: items,
			readyToSave: true,
			message:''
		})
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				return {
					id: form.getAttribute('data-id'),
					//name: encodeURIComponent(form.querySelector('.name').value),
					firstname: encodeURIComponent(form.querySelector('.firstname').value),
					lastname: encodeURIComponent(form.querySelector('.lastname').value),
					// graduation_year: encodeURIComponent(form.querySelector('.graduation_year option:checked').value),
					bio: encodeURIComponent(form.querySelector('.bio').value),
					// isSpotlight: form.querySelector('.isSpotlight').checked,
					show_id: encodeURIComponent(form.querySelector('.show_id').value),
					show_title: encodeURIComponent(form.querySelector('.show_id').selectedOptions[0].innerText),
					part: encodeURIComponent(form.querySelector('.part').value),
					head_shot: form.querySelector('img') ? form.querySelector('img').getAttribute('data-src') : ''
				}
			} else {
				return item
			}
		})

		this.setState({
			items: items,
			readyToSave: true,
			message: ''
		})
	}

	handleSaveChanges(){
		// Create the data to store.
		var data = {
			items: this.state.items,
		}

		// Save the items to the API.
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: {
				filename: 'bios',
				content: JSON.stringify(data)
			}
		}).then( (response) => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleShowSelect(e){
		this.setState({
			currentShowId: e.target.value
		})
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	render() {
		return (
			<section className="container edit bios_container">
				<h2>Cast Bios</h2>
				{ this.state.readyToSave ?
						<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
						null
				}
				{
					this.state.message.length ?
						<p className="message">{this.state.message}</p> :
						null
				}

				<form onChange={this.handleShowSelect.bind(this) } onSubmit={this.handleSubmit.bind(this)}>
					<ShowSelect shows={this.state.shows} selectedShowId={this.state.currentShowId != null && this.state.shows.length && this.state.shows.filter( show => show.id === this.state.currentShowId ).length ?
						this.state.shows.filter( show => show.id === this.state.currentShowId )[0].id :
						-1} />
				</form>

				<List
					items={this.state.items.filter( item => item.show_id === this.state.currentShowId )}
					shows={this.state.shows}
					remove={this.handleItemRemove.bind(this)}
					update={this.handleItemUpdate.bind(this)}
					submit={this.handleSubmit.bind(this)}
					handleImageUploadComplete={this.handleImageUploadComplete.bind(this)}
				/>
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add New Cast Member</button>
			</section>
		)
	}
}

export default Bios



// WEBPACK FOOTER //
// ./src/pages/bios.js